/**
 * terminal_hacker.js — Finance
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Philosophy:
 *   Goal:         Maximum financial detail density, traditional corporate rigor
 *   Hierarchy:    Experience (impact) → Projects/Initiatives → Skills (sidebar) → Credentials (sidebar)
 *   Divider:      Line — conservative 1.5px clean line under section titles (standard for Wall Street)
 *   Density:      Compact — page margins 20px, tight padding, packed with details
 *   Typography:   Georgia serif primary (classic Wall Street/FT register),
 *                 Inter sans-serif secondary for sidebar details
 *   Audience:     Investment Bankers, Private Equity Analysts, Chartered Accountants (CA), CFAs
 *
 * Visual Signature:
 *   - Traditional right sidebar layout (sidebar-right) housing skills categorisation, education details
 *     and financial certifications (CFA, CPA, CA)
 *   - Main column lists heavy professional history with impact metrics (experience-impact)
 *   - Densely structured, serif typography, dark teal-navy professional accents
 */

export const terminal_hacker = {
  id: 'terminal-hacker',
  version: 3,
  renderer: 'enterprise',
  name: 'Finance',
  layout: 'sidebar-right',
  theme: 'classic-navy',
  density: 'compact',
  sectionDividerStyle: 'line',
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'skills', 'education', 'certifications'],
  components: {
    header: 'header-split',
    experience: 'experience-impact',
    projects: 'projects-case-study',
    skills: 'skills-categorized',
    education: 'education-sidebar',
  },
  layouts: {
    'sidebar-right': {
      component: 'sidebar-right',
      slots: {
        header: ['personal-info'],
        sidebar: ['skills', 'education', 'certifications'],
        main: ['summary', 'experience', 'projects'],
      },
      overrides: {
        '--font-family-primary': '"Georgia", "Times New Roman", serif',
        '--font-family-secondary': '"Inter", "Helvetica Neue", sans-serif',
        '--color-primary': '#0D6E6E', // Wall Street Teal
        '--color-secondary': '#111827',
        '--color-accent': '#10B981',
        '--color-text-main': '#1F2937',
        '--color-text-light': '#4B5563',
        '--color-border': '#B2D8D8',
        '--color-bg-page': '#FFFFFF',
        '--layout-sidebar-width': '200px',
        '--layout-column-gap': '16px',
        '--layout-sidebar-bg': '#F0FAFA', // Cool teal sidebar tint
        '--layout-sidebar-padding': '12px',
        '--layout-sidebar-border': '1px solid #CBD5E1',
        '--spacing-margin': '20px',
        '--spacing-section-mb': '10px',
        '--spacing-item-mb': '8px',
        '--spacing-bullet-gap': '3px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '22pt',
    '--weight-display': '700',
    '--heading-weight': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--border-thickness-heading': '1.5px',
    '--bullet-style': 'disc',
    '--font-size-heading': '8.5pt',
    '--font-size-body': '9pt',
    '--font-size-bullet': '8.8pt',
    '--line-height-body': '1.4',
  },
};

export default terminal_hacker;
